<!--
=============================================================================
setera-web
=============================================================================
Copyright (c) 2025 HG Digital/Setera
Todos os direitos reservados.

Este software é confidencial e de propriedade da HG Digital/Setera.
Seu uso está sujeito aos termos do contrato de licença.
-----
Criado em : 08-01-2025
Autor     : System
Projeto   : setera-web
Versão    : 1.0.0
=============================================================================
-->

<div class="main-page bi">
  <div class="container-fluid">
    <!-- LINHA TITULO -->
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Business Intelligence</h1>
        <button
          *ngIf="showEmbeddedDashboard && selectedDashboard"
          class="btn btn-secondary btn-sm mt-2"
          (click)="backToDashboardList()"
        >
          ← Voltar para lista de dashboards
        </button>
      </div>
    </div>

    <!-- Lista de Dashboards -->
    <div *ngIf="showDashboardList" class="row mt-3">
      <div class="col-12">
        <h2 class="mb-3">Selecione um dashboard para visualizar</h2>

        <!-- Loading State -->
        <div *ngIf="isLoadingDashboards" class="loading-container">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-3">Carregando dashboards...</p>
        </div>

        <!-- Error State -->
        <div
          *ngIf="errorMessage && !isLoadingDashboards"
          class="error-container"
        >
          <div class="alert alert-danger" role="alert">
            <h4 class="alert-heading">Erro ao carregar dashboards</h4>
            <p>{{ errorMessage }}</p>
            <hr />
            <button class="btn btn-primary" (click)="loadDashboards()">
              Tentar novamente
            </button>
          </div>
        </div>

        <!-- Lista de Dashboards -->
        <div
          *ngIf="!isLoadingDashboards && !errorMessage && dashboards.length > 0"
          class="row mt-3"
        >
          <div
            *ngFor="let dashboard of dashboards"
            class="col-lg-6 col-md-6 my-2"
          >
            <a (click)="selectDashboard(dashboard)" style="cursor: pointer">
              <div class="card justify-content-center text-center">
                <div>
                  <img
                    src="assets/img/icons-page/report.svg"
                    height="55"
                    alt="Dashboard"
                  />
                  <h5>
                    {{
                      dashboard.dashboard_title || "Dashboard " + dashboard.id
                    }}
                  </h5>
                  <p class="text-muted small mb-0" *ngIf="dashboard.status">
                    Status: {{ dashboard.status }}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- Mensagem quando não há dashboards -->
        <div
          *ngIf="
            !isLoadingDashboards && !errorMessage && dashboards.length === 0
          "
          class="alert alert-info mt-3"
        >
          <h4 class="alert-heading">Nenhum dashboard disponível</h4>
          <p>Não há dashboards disponíveis no momento.</p>
        </div>
      </div>
    </div>

    <!-- Container do Dashboard Embedado -->
    <div *ngIf="showEmbeddedDashboard" class="row mt-2">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h2 *ngIf="selectedDashboard" class="mb-0" style="font-size: 1.5rem">
            {{ selectedDashboard.dashboard_title }}
          </h2>
          <div class="d-flex gap-2">
            <button
              *ngIf="selectedDashboard && !isLoading && !errorMessage"
              class="btn btn-primary btn-sm"
              (click)="toggleFullscreen()"
              [title]="isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'"
            >
              <i
                [class]="isFullscreen ? 'fas fa-compress' : 'fas fa-expand'"
              ></i>
              {{ isFullscreen ? " Sair da tela cheia" : " Tela cheia" }}
            </button>
          </div>
        </div>
        <div
          #biContainer
          class="bi-container"
          [class.fullscreen]="isFullscreen"
        >
          <button
            *ngIf="isFullscreen"
            class="btn btn-primary btn-sm bi-fullscreen-exit-btn"
            type="button"
            (click)="toggleFullscreen()"
            title="Sair da tela cheia"
          >
            ✕ Sair da tela cheia
          </button>
          <!-- Loading State -->
          <div *ngIf="isLoading" class="loading-container">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
            <p class="mt-3">
              Carregando dashboard: {{ selectedDashboard?.dashboard_title }}...
            </p>
          </div>

          <!-- Error State -->
          <div *ngIf="errorMessage && !isLoading" class="error-container">
            <div class="alert alert-danger" role="alert">
              <h4 class="alert-heading">Erro ao carregar dashboard</h4>
              <p>{{ errorMessage }}</p>
              <hr />
              <button class="btn btn-primary" (click)="reloadDashboard()">
                Tentar novamente
              </button>
              <button
                class="btn btn-secondary ml-2"
                (click)="backToDashboardList()"
              >
                Voltar para lista
              </button>
            </div>
          </div>

          <div *ngIf="selectedDashboard && !errorMessage" class="bi-layout">
            <aside *ngIf="!isLoading" class="bi-sidebar">
              <div class="bi-filters-panel">
                <h6 class="mb-3">Filtros</h6>
                <div class="bi-filters-body">
                  <div class="mb-2">
                    <label class="small mb-1">{{
                      isFiveMonthsDashboard ? "Mês inicial" : "Data inicial"
                    }}</label>
                    <input
                      [type]="
                        isFiveMonthsDashboard ? 'month' : 'datetime-local'
                      "
                      step="1"
                      class="form-control form-control-sm"
                      [placeholder]="
                        isFiveMonthsDashboard
                          ? 'mm/aaaa'
                          : 'dd/mm/aaaa hh:mm:ss'
                      "
                      [(ngModel)]="filterFromDttm"
                    />
                  </div>

                  <div class="mb-2">
                    <label class="small mb-1">{{
                      isFiveMonthsDashboard ? "Mês final" : "Data final"
                    }}</label>
                    <input
                      [type]="
                        isFiveMonthsDashboard ? 'month' : 'datetime-local'
                      "
                      step="1"
                      class="form-control form-control-sm"
                      [placeholder]="
                        isFiveMonthsDashboard
                          ? 'mm/aaaa'
                          : 'dd/mm/aaaa hh:mm:ss'
                      "
                      [(ngModel)]="filterToDttm"
                    />
                  </div>

                  <div class="mb-2">
                    <label class="small mb-1">Empresa</label>
                    <mat-form-field
                      appearance="outline"
                      class="w-100 mat-field-sm"
                    >
                      <mat-select
                        multiple
                        [(value)]="selectedEmpresaIds"
                        [disabled]="selectedDivisaoIds.length > 0"
                        (selectionChange)="onEmpresaChange()"
                      >
                        <mat-option
                          class="bi-clear-option"
                          (click)="
                            $event.stopPropagation(); clearEmpresaSelection()
                          "
                        >
                          Desmarcar todos
                        </mat-option>
                        <mat-option
                          *ngFor="let item of empresas"
                          [value]="item.id"
                        >
                          {{ item.nome }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="mb-2">
                    <label class="small mb-1">Divisão</label>
                    <mat-form-field
                      appearance="outline"
                      class="w-100 mat-field-sm"
                    >
                      <mat-select
                        multiple
                        [(value)]="selectedDivisaoIds"
                        [disabled]="selectedEmpresaIds.length > 0"
                        (selectionChange)="onDivisaoChange()"
                      >
                        <mat-option
                          class="bi-clear-option"
                          (click)="
                            $event.stopPropagation(); clearDivisaoSelection()
                          "
                        >
                          Desmarcar todos
                        </mat-option>
                        <mat-option
                          *ngFor="let item of divisoesFiltradas"
                          [value]="item.id"
                        >
                          {{ item.nome }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="mb-2">
                    <label class="small mb-1">Alarme</label>
                    <mat-form-field
                      appearance="outline"
                      class="w-100 mat-field-sm"
                    >
                      <mat-select multiple [(value)]="selectedAlarmeNames">
                        <mat-option
                          class="bi-clear-option"
                          (click)="
                            $event.stopPropagation(); clearAlarmeSelection()
                          "
                        >
                          Desmarcar todos
                        </mat-option>
                        <mat-option
                          *ngFor="let nome of alarmeOptions"
                          [value]="nome"
                        >
                          {{ nome }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="mb-3" *ngIf="!isDriverDashboard">
                    <label class="small mb-1">Terminal</label>
                    <mat-form-field
                      appearance="outline"
                      class="w-100 mat-field-sm"
                    >
                      <mat-select multiple [(value)]="selectedTerminalIds">
                        <mat-option
                          class="bi-clear-option"
                          (click)="
                            $event.stopPropagation(); clearTerminalSelection()
                          "
                        >
                          Desmarcar todos
                        </mat-option>
                        <mat-option
                          *ngFor="let item of terminaisFiltrados"
                          [value]="item.id"
                        >
                          {{ item.placa || "ID " + item.id }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="mb-3" *ngIf="isDriverDashboard">
                    <label class="small mb-1">Motorista</label>
                    <mat-form-field
                      appearance="outline"
                      class="w-100 mat-field-sm"
                    >
                      <mat-select multiple [(value)]="selectedMotoristaIds">
                        <mat-option
                          class="bi-clear-option"
                          (click)="
                            $event.stopPropagation(); clearMotoristaSelection()
                          "
                        >
                          Desmarcar todos
                        </mat-option>
                        <mat-option
                          *ngFor="let item of motoristasFiltrados"
                          [value]="item.id"
                        >
                          {{ item.nome }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <small
                  *ngIf="!hasCompanyOrDivisionSelected"
                  class="text-danger d-block mb-2"
                >
                  Selecione ao menos uma empresa ou uma divisão para aplicar os
                  filtros.
                </small>

                <div class="d-flex justify-content-between">
                  <button
                    class="btn btn-outline-secondary btn-sm"
                    (click)="clearFilters()"
                  >
                    Limpar
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    [disabled]="!canApplyFilters"
                    (click)="applyFilters()"
                  >
                    {{ isApplyingFilters ? "Aplicando..." : "Aplicar filtros" }}
                  </button>
                </div>
              </div>
            </aside>

            <section class="bi-main">
              <div
                id="superset_embedding_div_class"
                #dashboardMountPoint
                class="dashboard-container"
                style="
                  width: 100%;
                  height: 100%;
                  min-height: 800px;
                  background-color: #f5f5f5;
                "
              ></div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
